import fectx from 'deps/fectx';
import { parseQueryString } from 'utils/url';
import { getConfig } from 'helper/configManager';
import { getAuth } from './configAuth';

const __DEV__ = process.env.NODE_ENV === 'development';
const ENABLE_PROXY = true;

const queryStr = parseQueryString(window.location.search);
const config = getConfig();

const ApiTokenRest = "SW9zQXBpfGNiNzNlNTQ5OGQxMmI0MGNmMTQ0NQ==";
const ApiTokenW2api = "QWN0QXBpfDZjYXRyZW9mMGpwbzM4ZWI0MElINDY1ZGtsZnVv";

export function getApiToken(){
  let baseUrl = getBaseURL()
  if(baseUrl.indexOf('w2api')!== -1){
    return ApiTokenW2api
  }else if(baseUrl.indexOf('rest')!== -1){
    return ApiTokenRest
  }
  return ''
}
export function getBaseURL(){
  return __DEV__ && ENABLE_PROXY ? '' : config.apiEndpoint
}

const fectxInstance = fectx.create({
  baseURL: getBaseURL(),
  timeout: 4 * 1000,
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
    ApiToken: getApiToken(),
  },
  transformRequest: [data => JSON.stringify(data)],
  validateStatus: _status => _status !== 401 && _status !== 404,
});

fectxInstance.interceptors.request.use(config => {
  const authConfig = getAuth();
  if (config.noAuthor !== true && authConfig.key && authConfig.value) {
    config.headers[authConfig.key] = authConfig.value;
  }

  if (queryStr.UA) {
    config.headers['user-agent'] = queryStr.UA;
  } else if (queryStr.ua) {
    config.headers['user-agent'] = queryStr.ua;
  }

  return config;
});

if (__DEV__ && ENABLE_PROXY) {
  fectxInstance.interceptors.request.use(fectxConfig => {
    fectxConfig.headers['use-proxy'] = 'true';
    fectxConfig.headers['x-proxy-target'] = 'http:' + config.apiEndpoint;
    return fectxConfig;
  });
}
export default fectxInstance;
